export const API_URL = process.env.REACT_APP_API_URL
export const DEFENDER_URL = process.env.REACT_APP_DEFENDER_URL || 'https://defender.protexxa.com'
